import { translationsDashboard_da } from "./translationsDashboard.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationsDashboard_en } from "./translationsDashboard.en";
import { translationsDashboard_sv } from "./translationsDashboard.sv";

export const translationsDashboard = defineDashboardTranslations({
  da: translationsDashboard_da,
  en: translationsDashboard_en,
  sv: translationsDashboard_sv,
});
